import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import { Link } from "react-router-dom";
import EventFinished from "src/components/EventFinished";

const AllYouCanEat2025 = () => {
  const { t, i18n } = useTranslation();
  return (
    <AllYouCanEat2025Div>
      <Hero
        bgImage={"promotions/dining/all-you-can-eat-2025/all-you-can-eat_header-image_2560x800px_25-09-09.jpg"}
        buttonSettings={null}
        darkenBg={0}
        // mainHeroText={t("allYouCanEat2025.title")}
        title={t("allYouCanEat2025.title")}
        descriptionBgColor="var(--red)"
        fluid={true}
      />
      <EventFinished
        scheduleKeyName="allYouCanEat2025"
        eventType="promotions"
      />
      <TitleSection
        as={"h2"}
        title={t("allYouCanEat2025.heading")}
        text={t("allYouCanEat2025.description")}
        dark={true}
      />
      <MainContentDiv>
        <container-div>
          <Row className="g-4 justify-content-center" xs={1}>
            <Col md={8} className="text-center">
              <ReactMarkdown>{t("allYouCanEat2025.content")}</ReactMarkdown>
              <SpecialBox>
                <ReactMarkdown>{t("allYouCanEat2025.special")}</ReactMarkdown>
              </SpecialBox>
              <ReactMarkdown>{t("allYouCanEat2025.cta")}</ReactMarkdown>
              <a
                href={`/pdf/ALL-YOU-CAN-EAT-MENU.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("allYouCanEat2025.menuLink")}
              </a>
              <p className="note">{t("allYouCanEat2025.note")}</p>
            </Col>
          </Row>
        </container-div>
        <container-div>
          <ResponsiveImage
            src={`promotions/dining/all-you-can-eat-2025/all-you-can-eat-collage-01.jpg`}
            alt={t("allYouCanEat2025.title")}
            className="mt-5"
            />
        </container-div>
      </MainContentDiv>
    </AllYouCanEat2025Div>
  );
};
const AllYouCanEat2025Div = styled.div`
  width: 100%;
  height: auto;
  background: var(--white);
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .hero_container {
    min-height: 400px;
    @media (max-width: 768px) {
      h2 {
        font-size: 2rem;
      }
    }
  }
  .hero_text_container {
    /* display: none; */
    margin-top: 40px;
    h1 {
      text-shadow: none;
    }
  }
`;

const MainContentDiv = styled.div`
  padding: 40px 0;
  background: var(--lightblack);
  color: var(--white);
  width: 100%;
  h2:after {
    border-color: #e70a02;
  }
  container-div {
    text-align: center;
  }
  height: auto;
  width: 100%;
  text-align: left;
  .note {
    margin-top: 20px;
  }
  .desc strong {
    color: #ff9000;
  }
  a {
    font-size: 20px;
    margin: 20px 0;
    padding: 16px;
    width: 100%;
    max-width: 300px;
    font-weight: 300;
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-self: center;
    position: relative;
    color: var(--white);
    background: var(--red);
    &:hover {
      background-color: var(--white);
      color: var(--black);
    }
  }
`;
const SpecialBox = styled.div`
  background: var(--white);
  color: var(--black);
  padding: 20px 40px;
  margin: 20px 0;
`;
export default AllYouCanEat2025;
